/**
 * Central sound library — the ONLY place where audio files are imported.
 * To swap a sound: change the import here, nowhere else.
 */
import softRemoveSound from '../../assets/audio/ui/softRemove.mp3'
import softAddSound from '../../assets/audio/ui/softAdd.mp3'
import taskCheckSound from '../../assets/audio/ui/TaskCheck.mp3'
import doneSound from '../../assets/audio/ui/Done.mp3'
import { useSound } from '@/src/renderer/hooks/useSound'

/** Played when a badge/property is removed from a task */
export function useSoftRemoveSound() {
  return useSound(softRemoveSound, { volume: 0.5 })
}

/** Played when a badge/property is added to a task */
export function useSoftAddSound() {
  return useSound(softAddSound, { volume: 0.5 })
}

/** Played when a task is checked as done */
export function useTaskCheckSound() {
  return useSound(taskCheckSound, { volume: 0.5 })
}

/** Played when a larger workflow finishes — e.g. the Clarify inbox has
 *  been fully processed. */
export function useDoneSound() {
  return useSound(doneSound, { volume: 0.5 })
}
